import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

export default function TrustBadge() {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 0.2 }}
      className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full mb-8 relative overflow-hidden"
      style={{
        background:
          "linear-gradient(110deg, rgba(200,107,82,0.08) 0%, rgba(168,132,63,0.18) 50%, rgba(200,107,82,0.08) 100%)",
        backgroundSize: "200% 100%",
        border: "1px solid rgba(168,132,63,0.35)",
      }}
      data-testid="trust-badge"
    >
      <motion.div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "linear-gradient(110deg, transparent 35%, rgba(255,235,180,0.55) 50%, transparent 65%)",
          backgroundSize: "200% 100%",
        }}
        animate={{ backgroundPositionX: ["200%", "-100%"] }}
        transition={{ duration: 3.5, repeat: Infinity, ease: "linear" }}
      />
      <Sparkles size={13} className="text-[#A8843F] relative z-10" />
      <span className="relative z-10 text-[10px] md:text-[11px] uppercase tracking-[0.22em] font-medium text-walnut">
        1<sup>re</sup> boutique de sonothérapie · Compiègne &amp; Oise
      </span>
      <Sparkles size={13} className="text-[#A8843F] relative z-10" />
    </motion.div>
  );
}
